import React from "react";
import axios from "axios";
import { Provider } from "mobx-react";
import { RootStoreContext } from "./stores/RootStore";
import Pages from "./pages";
import moment from "moment-timezone";
import "./theme.scss";

moment.tz.setDefault("Asia/Manila");

class App extends React.Component {
  static contextType = RootStoreContext;
  render() {

    axios.defaults.baseURL = "https://ithuarsol.com/lgu-voters-website-api/";
    // axios.defaults.headers = {
    //   Authorization: `Bearer ${localStorage.getItem("QUNDRVNTX1RPS0VO")}`,
    // };

    return (
      <Provider {...this.context}>
        < Pages />
      </Provider>
    );
  }
}

export default App;
